import { Dropdown } from 'primeng/dropdown';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from '../../breadcrumb.service';
import { IUser } from '../../shared/Domains/IUser';
import { AppServiceManager } from '../../../common/services/appServiceManager';
import { AuthService } from '../../../common/services/auth.service';
import { SaleOrder } from '../point-of-sale/domain/SaleOrder';
import { LanguageService } from '../../LanguageService/Language.Service';
import { ICompany } from '../../shared/Domains/company';
import { IBranch } from '../../shared/Domains/branch';

import { MessageService } from 'primeng/api';
import { Configuration } from '../../../config/config';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isOpenPayLaterSale } from 'common/services/sale-order-payload.util';
@Component({
  selector: 'app-sale-orders',
  templateUrl: './sale-orders.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./sale-orders.component.css']
})
export class SaleOrdersComponent implements OnInit, AfterViewInit {
  @ViewChild("searchOrder", { static: false }) searchOrderInput!: ElementRef;
  loading = false;
  user!: IUser;
  saleOrder!: SaleOrder;
  first: number = 0;
  tabIndex: number = 0;
  from: any;
  to: any;
  date: any;
  sales: any[] = [];
  sourceSales: any[] = [];
  company!: ICompany;
  branch!: IBranch;
  deliverySales: any[] = [];
  sourceDeliverySales: any[] = [];
  isData = false;
  configMemberPath: any;
  categoryOptions: any[] = [];
  selectedCategoryOption: any;
  productOptions: any[] = [];
  selectedProductOption: any;
  orderStatus = 'fulfilled';
  paymentFilterOptions: any[] = [
    { label: 'All', value: 'All' },
    { label: 'Pay Later', value: 'Pay Later' },
  ];
  selectedPaymentFilter: string = 'All';
  private phoneByBuyerId = new Map<string, string>();
  confirmationMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;
  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private loader: NgxSpinnerService,
    public config: Configuration,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Sales / Sale Orders' }
    ]);
  }
  setLabel(label: string) {
    return this.LanguageService.GetCurrentLanguage("SaleOrdersComponent", label);
  }
  ngOnInit() {
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.user = AuthService.getLoggedInUser();
    this.saleOrder = new SaleOrder();
    this.orderStatus = "fulfilled";
    this.sales = [];
    this.date = new Date();
    this.isData = false;
    this.company = new ICompany();
    this.branch = new IBranch();
    this.getCompany();
    this.getBranch();
    this.configMemberPath = localStorage?.getItem('memberImagePath');
    this.categoryOptions = [{ label: "All", value: 'All' }];
    this.productOptions = [{ label: "All", value: 'All' }];
    this.selectedCategoryOption = 'All';
    this.selectedProductOption = 'All';

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['filter'] === 'All' || params['filter'] === 'Pay Later') {
        this.selectedPaymentFilter = params['filter'];
      } else if (params['t']) {
        this.selectedPaymentFilter = 'All';
      }
      this.getSales();
    });
  }

  ngAfterViewInit() {
    if (this.searchOrderInput?.nativeElement) {
      this.searchOrderInput.nativeElement.focus();
    }
  }
  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if (!this.company) {
      this.appServiceManager.get('companies/current').subscribe((res: any) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error: any) => {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if (!this.branch) {
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res: any) => {
        if (res) {
          this.branch = res;
        } else {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error: any) => {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
  }
  getSales() {
    this.loading = true;
    this.loader.show();
    const formatDate = (d: Date) =>
      d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);

    const fromDateStr = formatDate(this.from);
    const toDateStr = formatDate(this.to);
    const baseUrl = `branches/${this.user.branch}/sale-orders/reports/by-filters/from/${fromDateStr}/to/${toDateStr}/status`;

    forkJoin({
      fulfilled: this.appServiceManager.get(`${baseUrl}/fulfilled`),
      payLater: this.appServiceManager.get(`${baseUrl}/payLater`).pipe(catchError(() => of([]))),
      customers: this.appServiceManager.get(`branches/${this.user.branch}/customers/actions/short`).pipe(catchError(() => of([]))),
      employees: this.appServiceManager.get(`branches/${this.user.branch}/users/actions/search`).pipe(catchError(() => of([]))),
    }).subscribe((result: any) => {
      this.buildPhoneLookup(result.customers, result.employees);
      const fulfilled = Array.isArray(result.fulfilled) ? result.fulfilled : [];
      const payLater = Array.isArray(result.payLater) ? result.payLater : [];
      const byId = new Map<string, any>();
      [...fulfilled, ...payLater].forEach((order: any) => {
        if (!order?._id) return;
        const existing = byId.get(order._id);
        if (!existing) {
          byId.set(order._id, order);
          return;
        }
        // Prefer the record with higher paid (settled) over stale payLater copy
        const existingPaid = Number(existing.paid) || 0;
        const nextPaid = Number(order.paid) || 0;
        if (nextPaid >= existingPaid) {
          byId.set(order._id, order);
        }
      });
      this.processSalesResponse(Array.from(byId.values()));
    },
      (error: any) => {
        this.loading = false;
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  processSalesResponse(res: any[]) {
    let posSales = res.filter(x => x.status == 'POS');
    if (this.user.branch === '67f102774cf88446d8ce9929') {
      if (this.user.role === 'Pool Operator') {
        posSales = posSales.filter(item => item.category === 'Swimming items');
      }
      if (this.user.role === 'Bar Operator') {
        posSales = posSales.filter(item => item.category === 'Protien bar');
      }
      if (this.user.role === 'Spa Therapist') {
        posSales = posSales.filter(item => item.category === 'Spa Products');
      }
    }
    this.sourceSales = posSales.sort((a, b) => { return <any>new Date(b.invoiceDate) - <any>new Date(a.invoiceDate) });
    this.sourceDeliverySales = res.filter(x => x.status != 'POS');
    this.categoryOptions = [{ label: "All", value: 'All' }];
    this.productOptions = [{ label: "All", value: 'All' }];
    this.populateByCategory();
    this.populateByProduct();
    this.applyFilters();
    this.isData = true;
    this.loading = false;
    this.loader.hide();
    if (this.sales.length < 1) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No SaleOrder Record Found' });
      this.isData = false;
    }
  }

  applyFilters() {
    const matchesFilters = (sale: any) => {
      const matchesCategory = !this.selectedCategoryOption
        || this.selectedCategoryOption === 'All'
        || sale.category === this.selectedCategoryOption;
      const matchesProduct = !this.selectedProductOption
        || this.selectedProductOption === 'All'
        || (sale.products || []).some((product: any) => product.name === this.selectedProductOption);
      const matchesPayment = this.selectedPaymentFilter !== 'Pay Later'
        || isOpenPayLaterSale(sale);
      return matchesCategory && matchesProduct && matchesPayment;
    };

    this.sales = this.sourceSales.filter(matchesFilters);
    this.deliverySales = this.sourceDeliverySales.filter(matchesFilters);
    this.first = 0;
  }

  applyPaymentFilter() {
    this.applyFilters();
  }

  onPaymentFilterChange() {
    this.applyFilters();
    if (this.sales.length === 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
    }
  }
  populateByCategory() {
    const existingCategories = new Set(this.categoryOptions.map(opt => opt.value));
    const uniqueNewCategories = new Set();
    (this.sourceSales || []).forEach((report) => {
      if (report.category && !existingCategories.has(report.category)) {
        uniqueNewCategories.add(report.category);
      }
    });
    const newOptions = Array.from(uniqueNewCategories).map((category) => ({
      label: category,
      value: category,
    }));

    this.categoryOptions = this.categoryOptions.concat(newOptions);
  }
  populateByProduct() {
    const productNames = new Set<string>();
    this.sourceSales.forEach((sale) => {
      (sale.products || []).forEach((product: any) => {
        if (product.name) {
          productNames.add(product.name);
        }
      });
    });
    this.productOptions = this.productOptions.concat(
      Array.from(productNames).sort().map((name) => ({ label: name, value: name }))
    );
  }
  dropdownChange() {
    this.applyFilters();
    if (this.sales.length === 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
    }
  }
  handleTabChange(e: any) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      this.clearSearchDeliveryOrders();
    }
    if (index == 1) {
      this.tabIndex = 1;
      this.clear();
    }

  }

  searchLocal(value: any, type: any) {
    let matchedNumber: any[] = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (!value) {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = [...this.sourceSales].filter(
            (cust: any) => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : false);
        }

        const distinct = (value: any, index: number, self: any[]) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.sales = source.filter(distinct);

        if (this.sales.length === 0) {
          this.sales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.sales.length === 1) {
            this.first = 0;
          }
          this.sales = [...this.sales];
        }
      }
    } else {
      this.sales = Object.assign([], this.sourceSales);
      this.sales = [...this.sales];
    }
  }

  clear() {
    this.selectedCategoryOption = 'All';
    this.selectedProductOption = 'All';
    this.selectedPaymentFilter = 'All';
    this.saleOrder = new SaleOrder();
    this.searchLocal("", "");
    this.first = 0;
    this.isData = false;
    const date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  searchLocalDeliveryOrders(value: any, type: any) {
    let matchedNumber: any[] = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (!value) {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = [...this.sourceDeliverySales].filter(
            (cust: any) => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : false);
        }

        const distinct = (value: any, index: number, self: any[]) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.deliverySales = source.filter(distinct);

        if (this.deliverySales.length === 0) {
          this.deliverySales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.deliverySales.length === 1) {
            this.first = 0;
          }
          this.deliverySales = [...this.deliverySales];
        }
      }
    } else {
      this.deliverySales = Object.assign([], this.sourceDeliverySales);
      this.deliverySales = [...this.deliverySales];
    }
  }

  clearSearchDeliveryOrders() {
    this.saleOrder = new SaleOrder();
    this.searchLocalDeliveryOrders("", "");
    this.first = 0;
  }

  onPageChange(event: any) {
    this.first = event.first;
  }

  hotkeys($event: KeyboardEvent) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/point-of-sale");

    }
  }

  viewSaleOrder(order: any) {
    this.route.navigateByUrl('point-of-sale/' + order._id);
  }

  private extractPhone(source: any): string {
    if (!source) {
      return '';
    }
    const candidates = [
      source.phone,
      source.mobile,
      source.contact,
      source.contactDetail?.contact,
      source.contactDetails?.contact,
    ];
    for (const c of candidates) {
      const value = (c == null ? '' : String(c)).trim();
      if (value) {
        return value;
      }
    }
    return '';
  }

  getSoldToPhone(order: any): string {
    if (!order) {
      return '';
    }
    const soldToId = order.soldTo?._id || order.payLater?.buyerId;
    return this.extractPhone(order.soldTo)
      || this.extractPhone(order.payLater)
      || this.extractPhone(order.payLater?.buyer)
      || this.extractPhone(order.member)
      || this.extractPhone(order.employee)
      || (soldToId ? (this.phoneByBuyerId.get(String(soldToId)) || '') : '')
      || '';
  }

  private buildPhoneLookup(customers: any[], employees: any[]) {
    this.phoneByBuyerId = new Map<string, string>();
    (Array.isArray(customers) ? customers : []).forEach((person: any) => {
      const phone = this.extractPhone(person);
      if (person?._id && phone) {
        this.phoneByBuyerId.set(String(person._id), phone);
      }
    });
    (Array.isArray(employees) ? employees : []).forEach((person: any) => {
      const phone = this.extractPhone(person);
      if (person?._id && phone) {
        this.phoneByBuyerId.set(String(person._id), phone);
      }
    });
  }
  getTotalSales(): number {

    return this.sales?.reduce((acc, cur) => acc + (cur.total || 0), 0) || 0;
  }

  getRemainingBalance(order: any): number {
    if (!order) {
      return 0;
    }
    const stored = Number(order.remainingBalance) || 0;
    if (stored > 0) {
      return stored;
    }
    const paid = Number(order.paid) || 0;
    const status = String(order.orderStatus || '').toLowerCase();
    const payLaterAmount = Number(order?.payLater?.amount) || 0;
    const isPayLater = isOpenPayLaterSale(order)
      || status === 'paylater'
      || payLaterAmount > 0
      || !!order.payLater
      || String(order.modeOfPayment || '').toLowerCase() === 'pay-later';
    if (isPayLater) {
      const due = payLaterAmount || Number(order.total) || 0;
      const remaining = due - paid;
      return remaining > 0 ? Math.round(remaining) : 0;
    }
    return 0;
  }
  deleteOrder(order: { _id: string; }) {
    this.openConfirmationDialog("Are you sure you want to delete this order?", () => {
      this.loading = true;
      const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
      this.appServiceManager.delete(`branches/${branchId}/sale-orders/${order._id}`).subscribe(
          (res: any) => {
            if (res.status === true) {
              // Remove from local arrays
              this.sales = this.sales.filter(o => o._id !== order._id);
              this.sourceSales = this.sourceSales.filter(o => o._id !== order._id);
              this.deliverySales = this.deliverySales.filter(o => o._id !== order._id);
              this.sourceDeliverySales = this.sourceDeliverySales.filter(o => o._id !== order._id);

              this.getSales(); // Refresh the sales list after deletion
              this.loading = false;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order deleted successfully.' });
            } else {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
          },
          (error: any) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          }
        );
    });
  }

  private openConfirmationDialog(message: string, action: () => void): void {
    this.confirmationMessage = message;
    this.pendingConfirmationAction = action;
  }

  confirmPendingAction(): void {
    const action = this.pendingConfirmationAction;
    this.cancelPendingAction();
    action?.();
  }

  cancelPendingAction(): void {
    this.confirmationMessage = '';
    this.pendingConfirmationAction = null;
  }

  printAllInvoice(): void {
    let printContents: string;
    let currentDate = new Date();
    this.branch.name = "Sales Report - " + this.branch.name + " - " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    const allInvoiceEl = document.getElementById('allInvoice');
    if (!allInvoiceEl) {
      return;
    }
    printContents = allInvoiceEl.innerHTML;
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (!popupWin) {
      return;
    }
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
    <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: bottom;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `
    );
  }


}
